import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { submitStartAction } from '../actions';
import useFormId from './useFormId';
import useFormValidationSchema from './useFormValidationSchema';

function useSubmitStart(): () => void {
  const dispatch = useDispatch();
  const formId = useFormId();
  const validationSchema = useFormValidationSchema();
  return useCallback(() => {
    dispatch(submitStartAction(formId, validationSchema));
  }, [dispatch, formId, validationSchema]);
}

export default useSubmitStart;
